import styled from 'styled-components';
import { SnackbarContent } from '@material-ui/core';

export const ToastArea = styled.span`
  z-index: 999;
  svg {
    color: white;
  }
`;

export const Message = styled.span`
  display: flex;
  align-items: center;
  color: #fff;
`;

export const ToastType = styled(SnackbarContent)`
  background: ${({ color }) => (color ? color : 'ff9800')};
  color: white;
`;

export const MessageContent = styled.div`
  margin-left: 10px;
`;
